import { Animated } from 'react-native';

export default Animated;
